export const SAML = [
  {
    Lv: '1',
    HP: '31',
    MP: '6',
    POW: '4',
    SPD: '4',
    DEF: '2',
    EX: '0',
    NEXT: '24'
  },
  {
    Lv: '2',
    HP: '34',
    MP: '12',
    POW: '4',
    SPD: '7',
    DEF: '3',
    EX: '24',
    NEXT: '36'
  },
  {
    Lv: '3',
    HP: '35',
    MP: '16',
    POW: '6',
    SPD: '9',
    DEF: '4',
    EX: '60',
    NEXT: '50'
  },
  {
    Lv: '4',
    HP: '38',
    MP: '18',
    POW: '7',
    SPD: '11',
    DEF: '5',
    EX: '110',
    NEXT: '90'
  },
  {
    Lv: '5',
    HP: '40',
    MP: '20',
    POW: '7',
    SPD: '15',
    DEF: '7',
    EX: '200',
    NEXT: '180'
  },
  {
    Lv: '6',
    HP: '42',
    MP: '22',
    POW: '8',
    SPD: '19',
    DEF: '9',
    EX: '380',
    NEXT: '320'
  },
  {
    Lv: '7',
    HP: '42',
    MP: '27',
    POW: '9',
    SPD: '21',
    DEF: '11',
    EX: '700',
    NEXT: '600'
  },
  {
    Lv: '8',
    HP: '44',
    MP: '32',
    POW: '15',
    SPD: '21',
    DEF: '11',
    EX: '1300',
    NEXT: '1100'
  },
  {
    Lv: '9',
    HP: '45',
    MP: '34',
    POW: '15',
    SPD: '28',
    DEF: '14',
    EX: '2400',
    NEXT: '1600'
  },
  {
    Lv: '10',
    HP: '47',
    MP: '38',
    POW: '16',
    SPD: '32',
    DEF: '16',
    EX: '4000',
    NEXT: '2000'
  },
  {
    Lv: '11',
    HP: '50',
    MP: '40',
    POW: '17',
    SPD: '36',
    DEF: '18',
    EX: '6000',
    NEXT: '2200'
  },
  {
    Lv: '12',
    HP: '52',
    MP: '43',
    POW: '19',
    SPD: '36',
    DEF: '18',
    EX: '8200',
    NEXT: '2800'
  },
  {
    Lv: '13',
    HP: '54',
    MP: '45',
    POW: '27',
    SPD: '43',
    DEF: '21',
    EX: '11000',
    NEXT: '4000'
  },
  {
    Lv: '14',
    HP: '59',
    MP: '48',
    POW: '30',
    SPD: '48',
    DEF: '23',
    EX: '15000',
    NEXT: '4000'
  },
  {
    Lv: '15',
    HP: '63',
    MP: '50',
    POW: '34',
    SPD: '48',
    DEF: '23',
    EX: '19000',
    NEXT: '5000'
  },
  {
    Lv: '16',
    HP: '65',
    MP: '54',
    POW: '39',
    SPD: '55',
    DEF: '26',
    EX: '24000',
    NEXT: '6000'
  },
  {
    Lv: '17',
    HP: '69',
    MP: '62',
    POW: '39',
    SPD: '57',
    DEF: '27',
    EX: '30000',
    NEXT: '7000'
  },
  {
    Lv: '18',
    HP: '72',
    MP: '65',
    POW: '40',
    SPD: '60',
    DEF: '28',
    EX: '37000',
    NEXT: '9000'
  },
  {
    Lv: '19',
    HP: '79',
    MP: '68',
    POW: '41',
    SPD: '66',
    DEF: '31',
    EX: '46000',
    NEXT: '11000'
  },
  {
    Lv: '20',
    HP: '83',
    MP: '68',
    POW: '43',
    SPD: '69',
    DEF: '32',
    EX: '57000',
    NEXT: '13000'
  },
  {
    Lv: '21',
    HP: '87',
    MP: '76',
    POW: '45',
    SPD: '73',
    DEF: '34',
    EX: '70000',
    NEXT: '15000'
  },
  {
    Lv: '22',
    HP: '91',
    MP: '77',
    POW: '47',
    SPD: '77',
    DEF: '36',
    EX: '85000',
    NEXT: '15000'
  },
  {
    Lv: '23',
    HP: '99',
    MP: '83',
    POW: '48',
    SPD: '79',
    DEF: '37',
    EX: '100000',
    NEXT: '16000'
  },
  {
    Lv: '24',
    HP: '106',
    MP: '87',
    POW: '50',
    SPD: '82',
    DEF: '38',
    EX: '116000',
    NEXT: '18000'
  },
  {
    Lv: '25',
    HP: '113',
    MP: '91',
    POW: '51',
    SPD: '82',
    DEF: '38',
    EX: '134000',
    NEXT: '22000'
  },
  {
    Lv: '26',
    HP: '125',
    MP: '91',
    POW: '53',
    SPD: '85',
    DEF: '39',
    EX: '156000',
    NEXT: '26000'
  },
  {
    Lv: '27',
    HP: '138',
    MP: '94',
    POW: '54',
    SPD: '93',
    DEF: '43',
    EX: '182000',
    NEXT: '28000'
  },
  {
    Lv: '28',
    HP: '143',
    MP: '99',
    POW: '58',
    SPD: '93',
    DEF: '43',
    EX: '210000',
    NEXT: '30000'
  },
  {
    Lv: '29',
    HP: '152',
    MP: '105',
    POW: '65',
    SPD: '99',
    DEF: '46',
    EX: '240000',
    NEXT: '40000'
  }
]
